import React from 'react';
import { graphql, gql, compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Loader from '../../../../components/Loader'
import s from './WhyHostBlock1.css';
import WhyHostFormBlock1 from '../../../../components/siteadmin/WhyHostPageSettings/WhyHostFormBlock1'
import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';

class WhyHostBlock1 extends React.Component {

    static defaultProps = {
        data: {
            loading: false
        }
    };

    render() {
        const { data: { loading, getWhyHostPage }, title } = this.props
        let settingsCollection = {}
        if(loading){
            return <Loader type={"text"} />;
        } else {
            getWhyHostPage?.map((item, key) => {
                settingsCollection[item.name] = item.value;
                // Map multilingual fields
                settingsCollection[`${item.name}_en`] = item.value_en;
                settingsCollection[`${item.name}_fr`] = item.value_fr;
                settingsCollection[`${item.name}_it`] = item.value_it;
                settingsCollection[`${item.name}_pt`] = item.value_pt;
            });
            return <WhyHostFormBlock1 initialValues={settingsCollection} title={title} />
        }
    }
}

export default compose(
    withStyles(s),
    graphql(getWhyHostPageSettings, {
        options: {
            fetchPolicy: 'network-only',
            ssr: false
        }
    }),
)(WhyHostBlock1);